export enum LocationImageLevel {
    Mainstream = 0,
    Premium = 1,
    Leader = 2,
    Iconic = 3,
    Incomplete = 4
}